import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBaseModal = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  max-width: 840px;
  max-height: 88vh;
  overflow: auto;
  background-color: #fff;
  box-shadow: 24;
  padding: 2rem;
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export default StyledBaseModal;
